import { getFetch, postFetch, putFetch, deleteFetch } from '../utils/fetch';
import {
  FACILITY_DEVICE_API,
  FACILITY_DEVICE_EXPORT_API,
  FACILITY_DEVICE_EXPORT_WITH_IDS_API,
  FACILITY_DEVICE_GETALL_API,
} from './config';

export function getList(query) {
  return getFetch(`${FACILITY_DEVICE_API()}`, query);
}

export function getOne(_id) {
  return getFetch(`${FACILITY_DEVICE_API()}/${_id}`);
}

export function updateOne(_id, data = {}) {
  return putFetch(`${FACILITY_DEVICE_API()}/${_id}`, data);
}

export function deleteOne(_id) {
  return deleteFetch(`${FACILITY_DEVICE_API()}/${_id}`);
}

export function create(obj) {
  return postFetch(`${FACILITY_DEVICE_API()}`, obj);
}

export function exportData(query) {
  return getFetch(`${FACILITY_DEVICE_EXPORT_API()}`, {
    ...query,
  });
}

export function getAll() {
  return getFetch(`${FACILITY_DEVICE_GETALL_API()}`);
}

export function exportDataWithIds(query) {
  return postFetch(`${FACILITY_DEVICE_EXPORT_WITH_IDS_API()}`, {
    ...query,
  });
}



// WEBPACK FOOTER //
// ./src/api/facilityDeviceApi.js